import { useEffect, useState } from 'react';
import { api } from '../api';
import { AutocompleteOption } from '../components/Autocomplete';

type UseMachineLocationOptionsData = {
    line_uid: string,
    login: string,
};
export function useMachineLocationOptions(data: UseMachineLocationOptionsData) {
    const [machineLocationOptions, setMachineLocationOptions] = useState<AutocompleteOption[]>([]);

    useEffect(() => {
        api.machineLocationList(data).then((resData) => {
            setMachineLocationOptions(resData.map((item) => ({ text: item.name, value: item.name })));
        });
    }, [JSON.stringify(data)]);

    return machineLocationOptions;
}
